export const PAGE_CONFIG = {
  title: 'Churn',
  titleCN: '流失',
  subTitle: '',
  subTitleCN: '',
  path: '/engagement/churn',
  defaultTab: 'churn',
  tabList: [
    {
      id: 'churn',
      tabName: 'Churn',
      tabNameCN: '流失',
      isHaveNotification: true,
      notificationPath: '/engagement/churn',
      path: '/engagement/churn',
      logConfig: {
        pageId: '203401',
        pageName: 'nightingaleChurnUsers',
        extInfo: 'nightingaleChurnUsers',
        pagePath: '/engagement/churn',
      },
      filters: [
        {
          name: 'ChurnNightingaleAllFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/engagement/churn',
          componentList: [
            {
              name: 'CommonRow',
              className: '',
              type: 'layout',
              style: { marginTop: '10px' },
              props: {},
              children: [
                {
                  name: 'UserCompositionCo',
                  className: '',
                  type: 'view',
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/engagement/churn/metrics_trend'
                    }
                  },
                  children: [{
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: {
                      w: 12
                    },
                    children: [
                      {
                        name: 'WeekChurnUsersNightingaleContext',
                        className: '',
                        type: 'view',
                        style: {},
                        props: {
                          config: {
                            timeType: 'DAY',
                            enTitle : 'Churn Users and Churn%',
                            cnTitle : '流失用户和流失率',
                          }
                        }
                      },
                    ]
                  }]
                },
                {
                  name: 'UserCompositionCo',
                  className: '',
                  type: 'view',
                  props: {
                    config: {
                      api: '/api/v1/dashboard/pc/engagement/churn/churn_level_distribution'
                    }
                  },
                  children: [{
                    name: 'CommonCol',
                    className: '',
                    type: 'layout',
                    style: {},
                    props: {
                      w: 12
                    },
                    children: [
                      {
                        name: 'ChurnLevelDisContext',
                        className: '',
                        type: 'view',
                        style: {},
                        props: {
                          config: {
                            timeType: 'DAY',
                            enTitle : 'Churn level Distribution',
                            cnTitle : '流失用户等级构成',
                          }
                        }
                      },
                    ]
                  }]
                }
              ],
            },
            {
              name: 'CommonRow',
              className: '',
              type: 'layout',
              style: {},
              props: {},
              children:[
                {
                  name: 'RankListTabCo',
                  className: '',
                  style: {},
                  type: 'view',
                  data: {
                    regionDataType: 'country',
                    tabOrder : ['country', 'region', 'os']
                  },
                  children: [
                    {
                      name: 'MetricsRankListCo',
                      className: '',
                      type: 'view',
                      style: {},
                      props: {
                        config: {
                          api: '/api/v1/dashboard/pc/engagement/churn/breakdown',
                          metric: 'inflexion_new_churn',
                          haveCalBubble: false,
                          isUserQuota: true,
                          showConfig: {
                            showTable: true,
                            showChart: true,
                          },
                          comConfig:{
                            isHaveBar: true,
                            isHaveLine: true,
                            isHavePie: true,
                            isHaveShare: true
                          }
                        }
                      }
                    }
                  ]
                },
              ]
            },
            {
              name: 'OverallTableCo',
              className: '',
              type: 'view',
              style: { marginTop: '10px' },
              props: {
                config: {
                  api: {
                    tableApi: '/api/v1/dashboard/pc/engagement/churn/overall',
                    tableDownloadApi: '/api/v1/dashboard/pc/engagement/churn/overall/download',
                  },
                  componentMetrics: [
                    {
                      metricKey: 'new_churn_users',
                      reqMetricKey: 'new_churn_users',
                      enPercentWidth: 185,
                      cnPercentWidth: 185,
                      enWidth: 185,
                      cnWidth: 185,
                      enName: 'New Churn Users',
                      cnName: '新增流失用户',
                      rainbowKey: 'New Churn Users',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                    {
                      metricKey: 'acc_churn_users',
                      reqMetricKey: 'acc_churn_users',
                      enPercentWidth: 255,
                      cnPercentWidth: 255,
                      enWidth: 255,
                      cnWidth: 255,
                      enName: 'Accumulated Churn Users',
                      cnName: '累计流失用户',
                      rainbowKey: 'Accumulate Churn Users',
                      type: 'int',
                      decimal: 0,
                      percentDecimals: 1
                    },
                    {
                      metricKey: 'acc_churn_rate',
                      reqMetricKey: 'acc_churn_rate',
                      enPercentWidth: 255,
                      cnPercentWidth: 255,
                      enWidth: 255,
                      cnWidth: 255,
                      enName: 'Accumulate Churn%',
                      cnName: '累计流失率',
                      rainbowKey: 'Accumulate Churn%',
                      type: 'percent',
                      decimal: 2,
                      percentDecimals: 1
                    }
                  ],
                  slotConfig: {
                    isShowValueType : false,
                    isShowMetricsSettings : false,
                    isShowdownloadConfig : false
                  },
                  valueTypeConfig: {
                    valueType : 'dod',
                  },
                  otherParams: {
                    aggregates: ["sum", "avg_no_null"]
                  },
                  titleEn : 'Churn Users Details',
                  titleCn : '流失用户指标'
                }
              }
            },
          ]
        },
      ],
    }
  ]
}